import IClinicalContact from '../../interfaces/IClinicalContact';
import React from 'react';
import { Card, CardBody } from 'react-bootstrap';
import AgeMapping from './ApplicationForm/AgeMapping';

interface ClinicalContactReviewEntryProps {
    cc: IClinicalContact;
    showSupervisor?: boolean;
}

interface DescriptionListItemProps {
    label: string;
    value: React.ReactNode;
}

const DescriptionListItem: React.FC<DescriptionListItemProps> = ({ label, value }) => (
    <>
        <dt className="col-5">{label}:</dt>
        <dd className="col-7">{value ?? '-'}</dd>
    </>
);

const formatDate = (dateString?: string | Date): string => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString();
};

const ClinicalContactReviewEntry: React.FC<ClinicalContactReviewEntryProps> = ({
    cc,
    showSupervisor = true,
}) => {
    return (
        <Card className="bg-light-subtle border-1 mb-2 p-0 rounded-top-4">
            <Card.Header>{cc.initials}</Card.Header>
            <CardBody>
                <dl className="row">
                    {cc.age && <DescriptionListItem label="Age" value={AgeMapping[cc.age]} />}
                    <DescriptionListItem label="Start date" value={formatDate(cc.startDate)} />
                    <DescriptionListItem label="No. of Sessions" value={cc.numberOfSessions} />
                    {showSupervisor && (
                        <DescriptionListItem label="Supervisor" value={cc.supervisor.name} />
                    )}
                    <DescriptionListItem label="Presenting problem" value={cc.presentingProblem} />
                    <DescriptionListItem label="Setting" value={cc.treatmentSetting} />
                </dl>
            </CardBody>
        </Card>
    );
};

export default ClinicalContactReviewEntry;
